export default __webpack_public_path__ + "static/media/illustration-algohealth-w@3x.cc7f5399.webp";